import type { FaireCategoryEntity } from "../../entity_types/category";

export const cat_bath_mats: FaireCategoryEntity = {
  token: "cat_bath-mats",
  type: "category",
  name: "Bath mats",
  level: 3,
  parentToken: "cat_home-decor-bath",
  href: "/category/home-decor/bath/bath-mats",
  meta: {
    source: "mock" as const,
    importedAt: "2026-03-24T00:00:00.000Z",
    importedBy: "data-model-migration",
  },
};
